import React, { Component } from 'react';

class TabletEquipment23 extends Component {
    render() {
        return (
            <div>
                <h1>사출기 23호기</h1>
            </div>
        );
    }
}

export default TabletEquipment23;